export const splitAdvisors = (value) =>
    value ? String(value).split("; ").filter(Boolean) : [];

export const formatAdvisors = (value) =>
    splitAdvisors(value).map((advisor) => advisor.replace(" | ", " (") + ")");
